import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LIONSComponent } from './lions/lions.component';
import { KINGSComponent } from './kings/kings.component';
import { VIKINGSComponent } from './vikings/vikings.component';
import { WARRIORSComponent } from './warriors/warriors.component';
import { GIANTSComponent } from './giants/giants.component';

import { Stats2018Component } from './stats2018/stats2018.component';
import { STATS2016Component } from './stats2016/stats2016.component';
import { STATS2017Component } from './stats2017/stats2017.component';

import { TEAMSComponent } from './teams/teams.component';
import { ALLTIMEComponent } from './alltime/alltime.component';

import { MostRunsOverallComponent } from './most-runs-overall/most-runs-overall.component';
import { MostWicketOverallComponent } from './most-wicket-overall/most-wicket-overall.component';

import { NavBarTeamsComponent } from './nav-bar-teams/nav-bar-teams.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {path: 'teams/list/lions', component: LIONSComponent},
  {path: 'teams/list/kings', component: KINGSComponent},
  {path: 'teams/list/vikings', component: VIKINGSComponent},
  {path: 'teams/list/warriors', component: WARRIORSComponent},
  {path: 'teams/list/giants', component: GIANTSComponent},
  {path: 'stats/2018', component: Stats2018Component},
  {path: 'stats/2017', component: STATS2017Component},
  {path: 'stats/2016', component: STATS2016Component},
  {path: 'teams', component: TEAMSComponent},
  {path: 'all-time', component: ALLTIMEComponent},
  {path: 'stats', component: Stats2018Component},
  {path: 'all-time/most-runs', component: MostRunsOverallComponent},
  {path: 'all-time/most-wickets', component: MostWicketOverallComponent},
  {path: 'teams/list', component: NavBarTeamsComponent},
  {path: '', component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
